import axios from "axios";

export const loadAllOptions = async (options, callback) => {
  const resp = await axios({
    method: "get",
    url: `/collections/product-options/products.json`,
  });

  const products = resp.data.products;

  return options.map((option) => {
    const foundProduct = products.find(
      (product) => product.handle == option.handle
    );
    option.product = foundProduct;
    return option;
  });
};
export let pageType;
if (window.collectionName?.includes("sticker")) {
  pageType = "sticker";
} else {
  pageType = window.collectionName?.split("-")[0] || "default";
}
